module.exports = __webpack_public_path__ + "img/cu.37464316.svg";